import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { CtaWhatsApp } from "../components/Cta";
import { Reveal } from "../components/motion";
import { FAQ_FULL } from "../data/faq";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function Faq() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_FULL.flatMap((cat) =>
      cat.items.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      }))
    ),
  };

  return (
    <>
      <Seo
        title="FAQ — Tout savoir sur les cartes digitales"
        description="NFC, iPhone, Android, prix (40 / 45 / 80 € TTC), délais, modification des liens, logo, packs : toutes les réponses sur les cartes digitales Noveocard."
        path="/faq"
        jsonld={[faqSchema]}
      />
      <PageHero
        dark
        eyebrow="FAQ"
        titleLines={["Les réponses,", "avant même les questions."]}
        description="Tout ce qu'il faut savoir sur la carte Noveocard : technologie NFC, compatibilité, personnalisation, prix, délais et commande."
      />

      <section className="bg-brume py-16 sm:py-24">
        <div className="container-nv max-w-4xl">
          {FAQ_FULL.map((cat, ci) => (
            <Reveal key={cat.category} delay={0.05} className={ci > 0 ? "mt-14" : ""}>
              <h2 className="font-display text-2xl font-bold tracking-tight text-nuit-900">
                {cat.category}
              </h2>
              <Accordion type="single" collapsible className="mt-5">
                {cat.items.map((item, i) => (
                  <AccordionItem
                    key={item.q}
                    value={`${ci}-${i}`}
                    className="mb-3 rounded-2xl border border-nuit-900/10 bg-white px-6 transition-colors data-[state=open]:border-electric/40"
                  >
                    <AccordionTrigger
                      className="py-5 text-left font-display text-base font-semibold text-nuit-900 hover:no-underline sm:text-lg"
                      data-testid={`faq-q-${ci}-${i}`}
                    >
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="pb-5 text-sm leading-relaxed text-steel sm:text-base">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          ))}

          <Reveal className="mt-16">
            <div className="grain relative overflow-hidden rounded-3xl bg-nuit-900 p-8 text-center text-white sm:p-12">
              <p className="font-display text-2xl font-bold sm:text-3xl">Une autre question ?</p>
              <p className="mx-auto mt-3 max-w-md text-white/70">
                Écrivez-nous directement sur WhatsApp : nous répondons en moins de 30 minutes.
              </p>
              <CtaWhatsApp
                label="Nous contacter sur WhatsApp"
                message="Bonjour Noveocard, j'ai une question sur vos cartes digitales."
                className="mt-7"
                testid="faq-cta-whatsapp"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
